"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplantBrandSize_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ImplantBrandSize_Factory = /** @class */ (function () {
    function ImplantBrandSize_Factory() {
    }
    ImplantBrandSize_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Diameter: model.Diameter,
            ImplantBrandId: model.ImplantBrandId,
            Length: model.Length,
            PlatformSize: model.PlatformSize,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Reference: model.Reference,
        };
        return result;
    };
    ImplantBrandSize_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Diameter: model.Diameter,
            ImplantBrandId: model.ImplantBrandId,
            Length: model.Length,
            PlatformSize: model.PlatformSize,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Reference: model.Reference,
        };
        return result;
    };
    return ImplantBrandSize_Factory;
}());
exports.ImplantBrandSize_Factory = ImplantBrandSize_Factory;
